export class TrackCommand {
    command: TrackCommandType;
    options?: any;
}

export enum TrackCommandType {
    START = 'start',
    STOP = 'stop',
    PAUSE = 'pause',
    COPY = 'copy',
    CUT = 'cut',
    PASTE = 'paste',
    ZOOM = 'zoom',
    CLEAR_REGION = 'clearRegion',
    BACKWARD = 'backward',
    FORWARD = 'forward',
    CHANGE_REGION = 'changeRegion',
    CLEAR_WAVESURFER = 'clearWaveSurfer',
    MOVE = 'move',
    ADD_MARKER = 'addMarker'
}